import React from 'react';
import Link from 'next/link';
import Collapse from '@mui/material/Collapse';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { trackClickEvent } from '@/utils/site-track';
import SvgStar from './SvgStar';
import SvgRecommend from './SvgRecommend';

type Props = {
  title: string;
  children: React.ReactNode;
  showArrow?: boolean;
  link?: string;
  sectionGroup?: string;
  dataEleGroup?: string;
  selectedTitle?: string;
  setSelectedTitle?: React.Dispatch<React.SetStateAction<string>>;
  isRecommend?: boolean;
  adviceIndex?: number;
  defaultChecked?: boolean;
};

const Section = (props: Props) => {
  const {
    title,
    children,
    showArrow = false,
    link,
    sectionGroup,
    dataEleGroup = 'resume-advice_content',
    selectedTitle,
    setSelectedTitle,
    isRecommend = false,
    adviceIndex,
    defaultChecked = false,
  } = props;

  const [checked, setChecked] = React.useState(defaultChecked);
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    setChecked(!checked);
    setSelectedTitle?.(title);
    sectionGroup && !checked && trackClickEvent(e);
  };

  React.useEffect(() => {
    if (selectedTitle && checked) {
      setChecked(selectedTitle === title);
    }
  }, [selectedTitle]);

  return (
    <>
      <li className="relative" key={title}>
        <div
          onClick={handleClick}
          id={sectionGroup && `${dataEleGroup}_${sectionGroup}_${adviceIndex}`}
          data-ele-id={`${sectionGroup}_${title}`}
          data-ele-group={sectionGroup && dataEleGroup}
          className={`cursor-pointer ${showArrow ? 'mb-4' : 'px-4 bg-white'} ${checked ? 'font-semibold' : `font-normal hover:font-semibold${showArrow ? '' : ' hover:bg-slate-100'}`}`}
        >
          <div
            className={`flex items-center ${showArrow ? '' : 'py-9 border-t border-t-black/[0.06]'}`}
          >
            {showArrow && (
              <ArrowDropDownIcon
                className={`transition-all duration-300 ${checked ? '!rotate-180 ' : ''}`}
              />
            )}
            {isRecommend && <SvgStar className="mr-1" />}
            <span className={`line-clamp-1 ${showArrow ? 'ml-2' : 'ml-0'}`}>
              {adviceIndex ? `${adviceIndex}. ${title}` : title}
            </span>
            {isRecommend && <SvgRecommend className="ml-2" />}
          </div>
        </div>
        {link && (
          <Link
            className={`text-black/65 ml-auto absolute right-7 top-9 ${checked ? 'opacity-100' : 'opacity-0 invisible'} transition-all duration-300 hover:underline`}
            href={link}
            onClick={(e) => trackClickEvent(e, true)}
            data-ele-id={`${sectionGroup}_${title}`}
            data-ele-group={`${dataEleGroup}_all`}
          >
            查看全文
          </Link>
        )}
      </li>
      <Collapse in={checked} timeout={300}>
        <div
          className={`bg-white ${showArrow ? 'leading-6.5 text-black/85 pb-0' : 'pb-9 px-7'}`}
        >
          {children}
        </div>
      </Collapse>
    </>
  );
};

export default Section;
